import React from "react";
import { Grid } from "@mui/material";
import "src/components/AlertAndNotification/notificationEndpoints.css";
import AlertApp from "src/components/Alarms/alarms";

const Issues = () => {
  return (
      <AlertApp />
  );
};

export default Issues;
